import { render, staticRenderFns } from "./AffiliateUserListDetail.vue?vue&type=template&id=e894b226&"
import script from "./AffiliateUserListDetail.vue?vue&type=script&lang=js&"
export * from "./AffiliateUserListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports